import { useHandleResize } from "@hook";
import { getSqlServerGuidHash, sendMetric, getWhatId, getAbTestMetrika } from "@utils";

import { inject, observer } from "mobx-react";
import { useState } from "react";

import "./style.scss";

const { VITE_WHAT_ID } = import.meta.env;

const Share = inject("mainStore")(
    observer(({ mainStore, offer, className = "" }) => {
        const abTest = mainStore.getMainStore("abTest");
        const abTestMetika = mainStore.getMainStore("abTestMetika");

        const isMobile = useHandleResize();
        const [shareListOpen, setShareListOpen] = useState(false);
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
        const isAbTestMetrika = getAbTestMetrika(abTest, offer?._id);

        const handleCopy = () => {
            navigator.clipboard.writeText(window.location.href).then(() => {
                mainStore.setMainStore("toast", { severity: "success", life: 4000, summary: "", detail: "Cсылка копирована" });
            });

            sendMetric("click_copy_share_link", {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: offer?._id,
                params3: getSqlServerGuidHash(offer.code, offer.vendor?._id),
                params4: offer?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });
        };

        const clickHandlerShareItem = (e, item) => {
            e.stopPropagation();
            switch (item.label) {
                case "Телеграм":
                    sendMetric("click_offer_share_telegram", {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: offer?._id,
                        params3: getSqlServerGuidHash(offer.code, offer.vendor?._id),
                        params4: offer?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: what_id,
                    });
                    break;
                case "ВКонтакте":
                    sendMetric("click_offer_share_vkontakte", {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: offer?._id,
                        params3: getSqlServerGuidHash(offer.code, offer.vendor?._id),
                        params4: offer?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: what_id,
                    });
                    break;
                case "Одноклассники":
                    sendMetric("click_offer_share_odnoklassniki", {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: offer?._id,
                        params3: getSqlServerGuidHash(offer.code, offer.vendor?._id),
                        params4: offer?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: what_id,
                    });
                    break;
                default:
                    break;
            }
            window.open(`${item.link}${window.location.href}`, "_blank");
            setShareListOpen(false);
        };

        const handleShare = (e) => {
            e.stopPropagation();
            sendMetric("click_offer_main_share", {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: offer?._id,
                params3: getSqlServerGuidHash(offer.code, offer.vendor?._id),
                params4: offer?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });

            if (navigator.share) {
                navigator
                    .share({
                        title: "RIS PROMO",
                        text: `${offer.title}`,
                        url: `${window.location.href}`,
                    })
                    .then(() => {})
                    .catch((error) => {
                        console.error("Something went wrong", error);
                    });
            } else {
                console.log("not supported");
            }
        };

        const getShareImgColor = () => {
            if (isMobile) {
                return "var(--color1)";
            }
            return shareListOpen ? "#FFF" : "var(--color1)";
        };

        return (
            <div
                className={` share ${shareListOpen ? "active" : ""} ${isMobile ? "mobile" : ""} ${className} `}
                onClick={
                    isMobile
                        ? (e) => handleShare(e)
                        : () => {
                              setShareListOpen(!shareListOpen);

                              if (!shareListOpen) {
                                  sendMetric("click_offer_main_share", {
                                      params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                                      params2: offer?._id,
                                      params3: getSqlServerGuidHash(offer.code, offer.vendor?._id),
                                      params4: offer?.code,
                                      params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                                      params7: null,
                                      params8: what_id,
                                  });
                              }
                          }
                }
            >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M9.22825 5.2405V1.59961L15.598 7.97117L9.22825 14.3427V10.7018C4.67846 10.7018 2.55995 12.3996 0.399994 14.3996C1.83203 9.59961 3.27091 7.82045 4.63203 6.79961C5.99314 5.77877 7.22067 5.44016 9.22825 5.2405Z"
                        fill={getShareImgColor()}
                    />
                </svg>

                <div className={`share_block ${shareListOpen ? "active" : ""}`}>
                    <div className="share__block_item" onClick={() => handleCopy()}>
                        Скопировать ссылку
                    </div>
                    {shareList.map((item, index) => (
                        <div key={index} onClick={(e) => clickHandlerShareItem(e, item)} className="share__block_item">
                            {item.label}
                        </div>
                    ))}
                </div>
            </div>
        );
    }),
);

const shareList = [
    {
        label: "Телеграм",
        link: "https://t.me/share/url?url=",
    },
    {
        label: "ВКонтакте",
        link: "http://vkontakte.ru/share.php?url=",
    },
    {
        label: "Одноклассники",
        link: "https://connect.ok.ru/offer?url=",
    },
];

export default Share;
